(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["puffo-control-center"] && !Shopify.designMode) return;
  try {
    
(function(){
  const section=document.getElementById('puffo-control-center');
  if(!section)return;
  const cards=[...section.querySelectorAll('[data-pcc-card]')];
  const reduce=window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if('IntersectionObserver' in window){
    const io=new IntersectionObserver((entries)=>{
      entries.forEach((entry)=>{
        if(entry.isIntersecting){
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    },{threshold:.12});
    cards.forEach((card,index)=>{
      card.style.transitionDelay=(index*70)+'ms';
      io.observe(card);
    });
  }else{
    cards.forEach(card=>card.classList.add('is-visible'));
  }

  function setInteractivePosition(card,event){
    const rect=card.getBoundingClientRect();
    const x=Math.min(1,Math.max(0,(event.clientX-rect.left)/rect.width));
    const y=Math.min(1,Math.max(0,(event.clientY-rect.top)/rect.height));
    const ry=(x-.5)*6.2;
    const rx=(.5-y)*5.2;
    const dx=(x-.5)*7;
    const dy=(y-.5)*6;

    card.style.setProperty('--rx',rx+'deg');
    card.style.setProperty('--ry',ry+'deg');
    card.style.setProperty('--px',(x*100)+'%');
    card.style.setProperty('--py',(y*100)+'%');
    card.style.setProperty('--depth-x',dx+'px');
    card.style.setProperty('--depth-y',dy+'px');
    card.style.setProperty('--img-x',(-dx*.55)+'px');
    card.style.setProperty('--img-y',(-dy*.55)+'px');
    card.style.setProperty('--edge-alpha',Math.min(.16,Math.abs(x-.5)*.18+Math.abs(y-.5)*.18));
  }

  function resetInteractivePosition(card){
    card.style.setProperty('--rx','0deg');
    card.style.setProperty('--ry','0deg');
    card.style.setProperty('--px','50%');
    card.style.setProperty('--py','50%');
    card.style.setProperty('--depth-x','0px');
    card.style.setProperty('--depth-y','0px');
    card.style.setProperty('--img-x','0px');
    card.style.setProperty('--img-y','0px');
    card.style.setProperty('--edge-alpha','0');
  }

  cards.forEach((card)=>{
    card.addEventListener('pointerdown',(event)=>{
      if(reduce)return;
      setInteractivePosition(card,event);
      card.classList.add('is-pressed');
      window.setTimeout(()=>card.classList.remove('is-pressed'),280);
    });

    if(reduce || !window.matchMedia('(pointer:fine)').matches)return;

    card.addEventListener('pointermove',(event)=>{
      setInteractivePosition(card,event);
    });

    card.addEventListener('pointerleave',()=>{
      card.classList.remove('is-pressed');
      resetInteractivePosition(card);
    });
  });
})();

(function(){
  const layer=document.querySelector('.puffo-os-layer');
  if(!layer)return;

  const signal=layer.querySelector('.puffo-os-signal');
  const zoneLabel=layer.querySelector('.puffo-os-signal-zone');
  const stateLabel=layer.querySelector('.puffo-os-signal-state');
  const fill=layer.querySelector('.puffo-os-rail-fill');
  const nodes=[...layer.querySelectorAll('.puffo-os-node')];
  const ambients=[...layer.querySelectorAll('.puffo-os-ambient')];

  const zones=[
    {
      key:'entry',
      label:'ENTRY',
      state:'HERO ONLINE',
      element:document.querySelector('.puffo-product-hero-wrap')
    },
    {
      key:'control',
      label:'CONTROL',
      state:'CORE ACTIVE',
      element:document.getElementById('puffo-control-center')
    },
    {
      key:'network',
      label:'NETWORK',
      state:'LINKS ACTIVE',
      element:document.getElementById('puffo-network')
    }
  ].filter(zone=>zone.element);

  let current='entry';

  function setZone(key){
    if(current===key)return;
    current=key;

    zones.forEach(zone=>{
      zone.element.classList.toggle('puffo-zone-active',zone.key===key);
    });

    nodes.forEach(node=>{
      node.classList.toggle('is-active',node.dataset.puffoZone===key);
    });

    ambients.forEach(ambient=>{
      ambient.classList.toggle('is-active',ambient.classList.contains('puffo-os-ambient--'+key));
    });

    const active=zones.find(zone=>zone.key===key);
    if(active){
      zoneLabel.textContent=active.label;
      stateLabel.textContent=active.state;
    }
  }

  function update(){
    const doc=document.documentElement;
    const max=Math.max(1,doc.scrollHeight-doc.clientHeight);
    const progress=Math.min(1,Math.max(0,window.scrollY/max));

    if(fill) fill.style.height=(progress*100)+'%';

    let closest=zones[0];
    let distance=Infinity;
    const center=window.innerHeight*.48;

    zones.forEach(zone=>{
      const rect=zone.element.getBoundingClientRect();
      const zoneCenter=rect.top+(rect.height/2);
      const d=Math.abs(zoneCenter-center);
      if(d<distance){
        distance=d;
        closest=zone;
      }
    });

    if(progress>.985){
      zoneLabel.textContent='ELO';
      stateLabel.textContent='SESSION COMPLETE';
      nodes.forEach(node=>node.classList.remove('is-active'));
      ambients.forEach(ambient=>ambient.classList.toggle('is-active',ambient.classList.contains('puffo-os-ambient--network')));
      zones.forEach(zone=>zone.element.classList.toggle('puffo-zone-active',zone.key==='network'));
      current='elo';
    }else if(closest){
      if(current==='elo') current='';
      setZone(closest.key);
    }
  }

  zones.forEach((zone,index)=>{
    if(index===0) zone.element.classList.add('puffo-zone-active');
  });

  let ticking=false;
  function requestUpdate(){
    if(ticking)return;
    ticking=true;
    requestAnimationFrame(()=>{
      update();
      ticking=false;
    });
  }

  window.addEventListener('scroll',requestUpdate,{passive:true});
  window.addEventListener('resize',requestUpdate,{passive:true});
  requestUpdate();

  if(signal){
    signal.addEventListener('click',()=>{});
  }
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["puffo-network"] && !Shopify.designMode) return;
  try {
    

(function(){
  const section=document.getElementById('puffo-network');
  if(!section)return;

  const cards=[...section.querySelectorAll('.pnet__card')];
  const reduce=window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const fine=window.matchMedia('(pointer:fine)').matches;

  function setPosition(card,event){
    const rect=card.getBoundingClientRect();
    const x=Math.min(1,Math.max(0,(event.clientX-rect.left)/rect.width));
    const y=Math.min(1,Math.max(0,(event.clientY-rect.top)/rect.height));
    const dx=(x-.5)*6;
    const dy=(y-.5)*5;

    card.style.setProperty('--n-px',(x*100)+'%');
    card.style.setProperty('--n-py',(y*100)+'%');
    card.style.setProperty('--n-rx',((.5-y)*4.6)+'deg');
    card.style.setProperty('--n-ry',((x-.5)*5.4)+'deg');
    card.style.setProperty('--n-dx',dx+'px');
    card.style.setProperty('--n-dy',dy+'px');
  }

  function reset(card){
    card.style.setProperty('--n-px','50%');
    card.style.setProperty('--n-py','50%');
    card.style.setProperty('--n-rx','0deg');
    card.style.setProperty('--n-ry','0deg');
    card.style.setProperty('--n-dx','0px');
    card.style.setProperty('--n-dy','0px');
  }

  cards.forEach(card=>{
    card.addEventListener('pointerdown',event=>{
      if(reduce)return;
      setPosition(card,event);
      card.classList.add('is-pressed');
      window.setTimeout(()=>card.classList.remove('is-pressed'),280);
    });

    if(reduce || !fine)return;

    card.addEventListener('pointermove',event=>setPosition(card,event));
    card.addEventListener('pointerleave',()=>{
      card.classList.remove('is-pressed');
      reset(card);
    });
  });
})();


  } catch(e) { console.error(e); }
})();
})();
